import { useMemo } from 'react';

/**
 * useChristmasSeason Hook
 * 
 * Determines if the current date falls within the Christmas season.
 * Active from today (November 26) through January 1st.
 * 
 * Returns:
 *   boolean - true if in Christmas season, false otherwise
 */
export default function useChristmasSeason() {
  return useMemo(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    
    const seasonStart = new Date(currentYear, 11, 1); // Month is 0-indexed, so 11 = December
    
    // Christmas season ends January 1st of the following year
    const seasonEnd = new Date(currentYear + 1, 0, 1); // Month 0 = January
    
    // Check if today is within the Christmas season
    const isChristmasSeason = today >= seasonStart && today < seasonEnd;
    
    return isChristmasSeason;
  }, []);
}
